import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Hammer, Users, FileText, Inbox, LogOut, Wrench } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/staff", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/staff/builds", label: "Builds & Estimates", icon: Hammer },
  { to: "/staff/customers", label: "Customers", icon: Users },
  { to: "/staff/invoices", label: "Invoices", icon: FileText },
  { to: "/staff/quotes", label: "Quote Requests", icon: Inbox },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/staff/login"); };

  return (
    <div className="min-h-screen bg-[#09090b] flex">
      <aside className="w-64 border-r border-zinc-800 bg-black flex flex-col fixed h-screen">
        <div className="h-16 flex items-center gap-2 px-6 border-b border-zinc-800 font-display font-black uppercase tracking-tighter">
          <Wrench className="text-yellow-500" size={22} /> J&amp;D<span className="text-yellow-500">Ops</span>
        </div>
        <nav className="flex-1 py-4">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`sidebar-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 text-sm font-semibold uppercase tracking-wide transition-colors duration-150 border-l-2 ${
                  isActive ? "border-yellow-500 text-yellow-500 bg-yellow-500/5" : "border-transparent text-zinc-400 hover:text-white"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-zinc-800 p-4">
          <p className="text-xs text-zinc-500 mb-1 truncate">{user?.email}</p>
          <button onClick={doLogout} data-testid="staff-logout"
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-yellow-500 transition-colors duration-150">
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
}
